'use strict';

import runConfigService from "./runConfigService.js";
import axios from 'axios';
import urlService from "./urlService.js";

function checkTicketStatus(queue, secKey, callback) {
    let /*deferred = $.Deferred(),*/
        ticketCookie,
        resolved = false;

    secKey = secKey || '';
    ticketCookie = _getTicketCookie(queue, secKey);

    if (ticketCookie === null || _hasBeenEnoughTime(ticketCookie)) {
        let ticketNumber = 0;

        // if switching between old and new, ignore the ticket cookie
        if (ticketCookie !== null && ticketCookie.id !== null) {
            if (ticketCookie.hasOwnProperty('queue')) {
                ticketNumber = ticketCookie.id;
            }
        }

        axios.get(_getTicketUrl(queue, ticketNumber),
            {headers: {client_id: runConfigService.getRunConfig().clientId}}).then((result) => {
            console.log(result.data);
            resolved = true;
            _saveCookie(queue, result.data, secKey);
            callback(result.data);
            // deferred.resolve(result);
        });
    } else {
        resolved = true;
        callback(ticketCookie);
        // deferred.resolve(ticketCookie);
        // _processTicketCheck(ticketCookie);
    }

    setTimeout(function () {
        if (!resolved) {
            callback({queueStatus: 'timedOut'});
            // deferred.resolve('error');
        }
    }, 8000);

    // return deferred;
}

function checkQueueStatus(queue, callback) {
    let /*deferred = $.Deferred(),*/
        resolved = false;

    axios.get(_getWaitingRoomUrl(queue), {headers: {client_id: runConfigService.getRunConfig().clientId}}).then((result) => {
        console.log(result.data);
        resolved = true;
        if (result.data.status === 'open') { // waiting rooms are always open now
            callback('open');
            // deferred.resolve('open');
        } else {
            console.error('Invalid waiting room or not set to "open"', result);
            callback('notopen');
            // deferred.resolve('notopen');
        }
    });

    setTimeout(function () {
        if (!resolved) {
            callback('error');
            // deferred.resolve('error');
        }
    }, 12000);

    // return deferred;
}

function deleteTicket(queue, secKey) {
    let ticket = _getTicketCookie(queue, secKey);

    if (ticket !== null) {
        _deleteTicketById(queue, ticket.id);
    }
}

function _deleteTicketById(queue, id) {
    axios.delete(_getTicketUrl(queue, id), {headers: {client_id: runConfigService.getRunConfig().clientId}});
    console.log("Ticket deleted: ", id);
    _deleteCookie(_getCookieName(queue));
}

function deleteAllQueueTickets() {
    let cookies = $.cookie();

    Object.keys(cookies).map(function (name) {
        if (name.substr(0, 'ticket_'.length) === 'ticket_') {
            try {
                let ticket = JSON.parse(cookies[name]);
                if (ticket.queueName) {
                    _deleteTicketById(ticket.queueName, ticket.id);
                }
            } catch (e) {
            }

        }
        return -1;
    })
}

function _saveCookie(queue, data, secKey) {
    let date = new Date(),
        minutes = 15;

    data.secKey = secKey;
    data.lastCallTime = new Date().getTime();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    $.cookie(_getCookieName(queue), JSON.stringify(data), {expires: date, path: '/'});
}

function _getWaitingRoomUrl(queue) {
    return urlService.getAwsUrl() + "/waiting-room/v1/queue/" + queue;
}

function _getCookieName(queue) {
    return 'ticket_' + queue;
}

function _getTicketCookie(queue, secKey) {
    let cookieName = _getCookieName(queue),
        cookieStr = $.cookie(cookieName),
        ticketCookie = cookieStr && cookieStr !== 'undefined' ? JSON.parse(cookieStr) : null;

    //Check to see if the quename for this page and the queue name in the cookie match if not then delete cookie
    if (ticketCookie !== null) {
        if (queue !== ticketCookie.queueName || ticketCookie.secKey !== secKey) {
            _deleteTicketById(queue, ticketCookie.id);
            ticketCookie = null;
        }
    }
    return ticketCookie;
}

function _deleteCookie(cookieName) {
    $.cookie(cookieName, null, {path: '/'});
}

function _hasBeenEnoughTime(cookie) {
    let reloadProtectionWaitTime = 15000,
        currentTime = new Date().getTime();

    return ((currentTime - reloadProtectionWaitTime) >= cookie.lastCallTime);
}

function _getTicketUrl(queue, ticketNumber) {
    return urlService.getAwsUrl() + '/waiting-room/v1/ticket' + (ticketNumber === 0 ? `?queue=${queue}` : `/${ticketNumber}`);
}

export default {
    checkQueueStatus: checkQueueStatus,
    checkTicketStatus: checkTicketStatus,
    deleteTicket: deleteTicket,
    deleteAllQueueTickets: deleteAllQueueTickets
};
